module.exports = __webpack_public_path__ + "img/we-help-en-espera.0cf9a8ea.png";